import React, { useCallback, useEffect, useRef } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $isCodeNode } from '@lexical/code';
import { $getRoot } from 'lexical';
import { $createDiffHunkNode } from '../customNodes/DiffHunkNode/DiffHunkNode';

export const DiffHunkPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const hasConverted = useRef(false);

  const convertDiffCodeBlocks = useCallback(() => {
    editor.update(() => {
      const root = $getRoot();
      const children = root.getChildren();
      let found = false;

      for (const node of children) {
        if (!$isCodeNode(node)) {
          continue;
        }

        if (node.getLanguage() !== 'diff') {
          continue;
        }

        found = true;
        const diffContent = node.getTextContent();
        const diffHunkNode = $createDiffHunkNode(diffContent);
        node.insertBefore(diffHunkNode);
        node.remove();
      }

      if (!found) {
        hasConverted.current = true;
      }
    });
  }, [editor]);

  useEffect(() => {
    convertDiffCodeBlocks();
  }, [convertDiffCodeBlocks]);

  useEffect(() => {
    return editor.registerUpdateListener(({ tags }) => {
      if (hasConverted.current) {
        return;
      }
      if (tags.has('historic') || tags.has('collaboration')) {
        return;
      }
      convertDiffCodeBlocks();
    });
  }, [editor, convertDiffCodeBlocks]);

  return null;
};
